import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

const WorkCombinationBarChart = (props) => {
    const INITIAL: any = []
    const [barChartData, setBarChartData] = React.useState(INITIAL);
    const [barChartOptions, setBarChartOptions] = React.useState({});

    React.useEffect(() => {
        setBarChartData([
            {data: props.data}
        ])
        setBarChartOptions({
            chart: {
                toolbar: {
                    show: true,
                },
                type: 'bar',

            },
            // colors: colors,
            plotOptions: {
                bar: {
                    borderRadius: 9,
                    columnWidth: '45%',
                    distributed: true,
                }
            },
            tooltip: {
                enabled: true
            },
            dataLabels: {
                enabled: true,
            },
            legend: {
                show: false
            },
            fill: {
                opacity: 1,
                colors: ['#05D20D'],
            },
            xaxis: {
                categories: props.categories,
                labels: {
                    trim: true,
                    minHeight: 70,
                    maxHeight: 70,
                    style: {
                        fontSize: '12px'
                    }
                },
                title: {
                    text: 'Work Combination Chart Analysis',
                }
            },
            yaxis: {
                title: {
                    text: 'Time %'
                }

            },
        })
    }, [props])

    return(
        <Chart options={barChartOptions} series={barChartData} type='bar' width={props.width} height={props.height} />
    )
}
WorkCombinationBarChart.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    categories: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
}

export default WorkCombinationBarChart;